export default "__VITE_ASSET__hn3f3MXWg4mIpdmMggDGaA__"